import React, { useState, useEffect } from "react";
import Body from "../Common/Body";
import moment from "moment";
import ContentCard from "../Common/Layout/ContentCard";
import useFetch from "../../hooks/useFetch";
import { OperatorsTable } from "./OperatorsTable";
import { useToast } from "@chakra-ui/react";

const AccessControl = () => {
  moment.locale();
  const [operatorsActions, setOperatorsActions] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();
  const { get, post } = useFetch();

  useEffect(() => {
    setIsLoading(true);

    get(`/users/roles/operators/actions`)
      .then(async (res) => {
        console.log(res);
        setOperatorsActions(res);
      })
      .catch((e) => {
        console.log(e);
        throw new Error(e);
      })
      .finally(
        get(`/users/roles/actions`)
          .then(async (res) => {
            setActionList(res);
          })
          .catch((e) => {
            console.log(e);
            throw new Error(e);
          })
          .finally(() => setIsLoading(false))
      );
  }, []);

  const handleSavePermission = async (newActionList) => {
    setIsSubmitting(true);
    await post(`/users/roles/operators/actions`, newActionList)
      .then((res) => {
        toast({
          title: "Permisos editados con éxito.",
          description: `Se han guardado los permisos`,
          status: "success",
          duration: 4000,
          isClosable: true,
        });
      })
      .catch((e) => {
        toast({
          title: "Se ha producido un error.",
          description:
            e?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <>
      <Body title={"Permisos de Operadores"}>
        <ContentCard>
          <OperatorsTable
            isLoading={isLoading}
            operatorsActions={operatorsActions}
            actionList={actionList}
            handleSavePermission={handleSavePermission}
            isSubmitting={isSubmitting}
          ></OperatorsTable>
        </ContentCard>
      </Body>
    </>
  );
};

export default AccessControl;
